export default __webpack_public_path__ + "static/media/new-message.a673b70c.wav";